// @flow
import JQueryView from '../../../common/JQueryView';
import DateRangePicker from '../../../common/DateRangePicker';

declare var $: any;

export default class Form3View extends JQueryView {
  constructor() {
    super('#form3');
    this.initDateRangePicker(this.$el);
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        locale: {
          format: 'Y/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'Y/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }
}
